<template>
    <div>
        <ModelYM
            :ym='ymd'
            @change="emit"
            :disabled="disabled"
            :label="label"
        />
    </div>
</template>

<script>
import ModelYM from '../../UI/models/ModelYM';

export default {
    name: 'ModelISOYM',
    components: {
        ModelYM,
    },
    data: ()=>({
        ymd: null,
    }),
    watch: {
        // ymd(val) {
        //     this.$emit('change', this.ymdToIso(val));
        // },
        value(val) {
            this.ymd = this.isoToYmd(val);
        },
    },
    methods: {
        emit(e){
            let iso = this.ymdToIso(e);
            if (iso.indexOf('NaN') == -1) {
                this.$emit('change', this.ymdToIso(e));
            }
        },
        isoToYmd(iso) {
            let pIso = this.parseIso(iso);
            return parseInt(`${pIso.year}${pIso.month}`);
        },
        ymdToIso(ymd) {
            let pYmd = this.parseYmd(ymd);
            return `${pYmd.year}-${pYmd.month}`+ (pYmd.year && pYmd.month ? '-01' : '');
        },
        parseYmd (ymd) {
            ymd = String(ymd);
            return {
                year: ymd.slice(0, 4),
                month: ymd.slice(4, 6),
            };
        },
        parseIso (iso) {
            iso = String(iso);
            if (iso.length > 0) {
                return {
                    year: iso.slice(0, 4),
                    month: iso.slice(5, 7),
                };
            } else {
                return {
                    year: '',
                    month: '',
                };
            }

        },
    },
    mounted() {
        this.ymd = this.isoToYmd(this.value);
    },
    props: {
        value: String,
        disabled: Boolean,
        coins: Number,
        label: {
            type: String,
            default: 'Месяц',
        },
    },
    model: {
        prop: 'value',
        event: 'change',
    },
};
</script>

<style scoped>

</style>